// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"44":"5f2c2548","330":"07fc65a5"}[chunkId] + ".chunk.css";
};